export default __webpack_public_path__ + "static/media/AU.a9157abc.svg";